export default __webpack_public_path__ + "static/media/galic.c9c692a5.svg";